import { render, staticRenderFns } from "./online_order_list.vue?vue&type=template&id=235ec965&scoped=true"
import script from "./online_order_list.vue?vue&type=script&lang=js"
export * from "./online_order_list.vue?vue&type=script&lang=js"
import style0 from "./online_order_list.vue?vue&type=style&index=0&id=235ec965&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ec965",
  null
  
)

export default component.exports